import React from 'react'
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';

import abilityBuild from '../../shared/CASL/appAbility';
import { checkRoles } from '../../hoc/CheckRoles';
import { RoleContext } from '../../shared/enums';
import { RootState } from '../../store';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Selection, IButtonProps, ICommandBarItemProps, ICommandBarStyles, IDialogContentProps, DialogType, Dialog, DialogFooter, PrimaryButton, DefaultButton, CommandBar, Pivot, PivotItem, mergeStyleSets } from '@fluentui/react';
import { connect, ConnectedProps } from 'react-redux';
import { IForwardRule } from '../../shared/interfaces';
import { Unsubscribe } from '@casl/ability';
import AddEditForwardRule from './AddEditForwardRule';
import forwardRulesService from '../../services/forwardRules.service';
import ForwardRulesTable from './ForwardRulesTable';
import { toastRef } from '../Layout/Layout';



const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};
const classNames = mergeStyleSets({
    overFlowHidden: {
        overflow: 'hidden'
    },
    detailsListRow: {
        '.ms-DetailsRow-check': {
            height: '100%',
            width: 36
        },
        '.ms-DetailsRow-fields .ms-DetailsRow-cell': {
            paddingLeft: 0

        }
    }
});


const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface ForwardRulesProps {

}

type Props = ForwardRulesProps & RouteComponentProps & PropsFromRedux;

export interface ForwardRulesState {
    commandBarItems: ICommandBarItemProps[],
    selectedForwardRule?: IForwardRule
    lateralPanelIsOpen: boolean,
    lateralPanelBodyContent: Function,
    lateralPanelSubmitFunction: Function,
    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogSubmitFunction: Function,
    loadingForwardRulesList: boolean
    forceForwardRulesTableRefresh: boolean,
    rulesCount: number
}


class ForwardRules extends React.Component<Props, ForwardRulesState> {
    unsubscribeFromAbility: Unsubscribe = () => { };
    private forwardRuleSelection: Selection;


    constructor(props) {
        super(props);

        this.forwardRuleSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.forwardRuleSelection.getSelection()[0] as IForwardRule;
                this.setState({ selectedForwardRule: selection });
            },
        });

        this.state = {
            commandBarItems: [],
            lateralPanelIsOpen: false,
            lateralPanelBodyContent: () => null,
            lateralPanelSubmitFunction: () => null,
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => null,
            loadingForwardRulesList: false,
            forceForwardRulesTableRefresh: false,
            rulesCount: 0
        }
    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {

            this.updateCommandBarItems();
        });

        if (this.props.currentAoo) {
            this.updateCommandBarItems();
        }
    }

    componentDidUpdate(oldProps: Props, oldState: ForwardRulesState) {
        if (oldProps.currentAoo !== this.props.currentAoo
            || oldState.selectedForwardRule !== this.state.selectedForwardRule) {
            this.updateCommandBarItems();

        }

    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
    }
    updateCommandBarItems = () => {

        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (abilityBuild.can('create', 'IForwardRule'))
            newCommandBarItems.push(
                {
                    key: 'addForwardRuleHandler',
                    iconProps: { iconName: 'Add' },
                    text: 'Aggiungi regola',
                    onClick: this.addForwardRuleHandler
                });

        if (abilityBuild.can('update', 'IForwardRule') && this.state.selectedForwardRule)
            newCommandBarItems.push(
                {
                    key: 'updateForwardRuleHandler',
                    iconProps: { iconName: 'Edit' },
                    text: 'Modifica regola',
                    onClick: this.updateForwardRuleHandler
                });

        if (abilityBuild.can('delete', 'IForwardRule') && this.state.selectedForwardRule)
            newCommandBarItems.push({
                key: 'deleteForwardRuleHandler',
                iconProps: { iconName: 'Delete' },
                text: 'Rimuovi regola',
                onClick: this.deleteForwardRuleHandler
            });


        this.setState({ commandBarItems: newCommandBarItems });

    }

    // Click sul button della commandbar
    addForwardRuleHandler = () => {
        this.setState(
            {
                selectedForwardRule: undefined,
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditForwardRule
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Nuova regola di inoltro'
                    loading={false}
                    selectedForwardRule={{}}
                    hideTitolarioField={false}
                    onSubmit={this.addForwardRuleLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                />

            }
        );
        this.forwardRuleSelection.setAllSelected(false);

    }

    // Click su salva del panel laterale
    addForwardRuleLateralPanelSubmit = (forwardRules: Partial<IForwardRule>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi creare una nuova regola di inoltro?',
            },
            confirmDialogSubmitFunction: () => { this.addForwardRuleConfirmDialogSubmit(forwardRules) }

        })

    }

    // Click su conferma del confirm dialog
    addForwardRuleConfirmDialogSubmit = (forwardRule: Partial<IForwardRule>) => {
        if (this.props.currentAoo) {
            this.setState({ loadingForwardRulesList: true });
            let { forceForwardRulesTableRefresh } = this.state

            forwardRulesService.addForwardRule(this.props.currentAoo.id, forwardRule)
                .then(result => {
                    this.setState({ forceForwardRulesTableRefresh: !forceForwardRulesTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: "Operazione completata",
                        detail: 'Regola creata correttamente',
                        life: 5000
                    })
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: 'Non \u00e8 stato possibile creare la regola',
                            life: 5000
                        });
                    }
                    this.setState({ loadingForwardRulesList: false });
                });

            this.setState({ confirmDialogIsOpen: false })

        }
    }
    // Click sul button della commandbar
    updateForwardRuleHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditForwardRule
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Modifica regola di inoltro'
                    loading={false}
                    selectedForwardRule={this.state.selectedForwardRule}
                    hideTitolarioField={false}
                    onSubmit={this.updateForwardRuleLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                />

            }
        );
    }

    // Click su salva del panel laterale
    updateForwardRuleLateralPanelSubmit = (forwardRule: Partial<IForwardRule>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi modificare la regola di inoltro?',
            },
            confirmDialogSubmitFunction: () => { this.updateForwardRuleConfirmDialogSubmit(forwardRule) }

        })

    }

    // Click su conferma del confirm dialog
    updateForwardRuleConfirmDialogSubmit = (forwardRule: Partial<IForwardRule>) => {
        if (this.props.currentAoo) {
            this.setState({ loadingForwardRulesList: true });
            let { forceForwardRulesTableRefresh } = this.state

            // in update forwardRules è sempre e solo 1 item
            forwardRulesService.updateForwardRule(this.props.currentAoo.id, forwardRule)
                .then(result => {
                    // Deseleziona l'elemento aggiornato in modo che, alla riapertura in modifica,
                    // l'utente riselezionasse dalla tabella aggiornata e ottenga i dati freschi.
                    // (Selection.onSelectionChanged non si scatena quando cambiano solo i dati dell'elemento.)
                    this.forwardRuleSelection.setAllSelected(false);

                    this.setState({ forceForwardRulesTableRefresh: !forceForwardRulesTableRefresh });

                    toastRef.current?.show({
                        severity: 'info',
                        summary: 'Operazione completata',
                        detail: `Regola aggiornata correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: 'Non \u00e8 stato possibile modificare la regola',
                            life: 5000
                        });
                    }
                    this.setState({ loadingForwardRulesList: false });
                });
            this.setState({ confirmDialogIsOpen: false })

        }
    }

    // Click sul button della commandbar
    deleteForwardRuleHandler = () => {
        let { selectedForwardRule } = this.state;
        if (selectedForwardRule) {
            this.setState(
                {
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: `Vuoi rimuovere la regola selezionata?`,
                    },
                    confirmDialogIsOpen: true,
                    confirmDialogSubmitFunction: () => { this.deleteForwardRuleConfirmDialogSubmit(selectedForwardRule) }
                }
            );
        }
    }

    // Click su conferma del confirm dialog
    deleteForwardRuleConfirmDialogSubmit = (forwardRule: Partial<IForwardRule> | undefined) => {
        if (this.props.currentAoo && forwardRule) {
            let { forceForwardRulesTableRefresh } = this.state

            forwardRulesService.deleteForwardRule(this.props.currentAoo.id, forwardRule.id!)
                .then(result => {
                    this.setState({ forceForwardRulesTableRefresh: !forceForwardRulesTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: 'Operazione completata',
                        detail: `Regola eliminata correttamente`,
                        life: 5000
                    });

                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: 'Non \u00e8 stato possibile eliminare la regola',
                            life: 5000
                        });
                    }
                    this.setState({ loadingForwardRulesList: false });
                });

            this.setState({ confirmDialogIsOpen: false });
            this.forwardRuleSelection.setAllSelected(false);
        }
    }

    dismissLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ lateralPanelIsOpen: false })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }


    onSelectForwardRuleHandler = (selected) => {
        this.setState({
            selectedForwardRule: selected
        })
    }
    render() {

        return (
            <React.Fragment>

                {this.state.lateralPanelBodyContent()}

                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>

                </Dialog>

                <div className="forward-rules-component flex flex-column p-nogutter" >

                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}

                        />
                    }
                    <div className="forward-rules-content flex flex-row">
                        <div className={"forward-rules-table col-12 flex flex-column position-relative " + classNames.overFlowHidden}>
                            <ForwardRulesTable
                                loadingForwardRulesTable={this.state.loadingForwardRulesList}
                                forwardRuleSelection={this.forwardRuleSelection}
                                forceTableRefresh={this.state.forceForwardRulesTableRefresh}
                                onSelectForwardRuleHandler={(selected) => this.onSelectForwardRuleHandler(selected)}
                                updateForwardRuleHandler={this.updateForwardRuleHandler!}
                                deleteForwardRuleHandler={this.deleteForwardRuleHandler!}
                            />

                        </div>
                    </div>
                </div>
            </React.Fragment >
        )
    }
}

export default connector(withRouter(checkRoles(ForwardRules, RoleContext.Aoo)));
